import React, { useState } from "react";
import "./JobSub.css";
import jobComImg1 from "../../Images/jobComImg1.jpg";
import jobComImg2 from "../../Images/jobComImg2.jpg";
import jobComImg3 from "../../Images/jobComImg3.jpg";
import jobComImg4 from "../../Images/jobComImg4.jpg";
import Slider from "../../Components/Service Partners/Trusted";
import jobImg1 from "../../Images/jobImg1.png";
import jobImg2 from "../../Images/jobImg2.png";
import jobImg3 from "../../Images/jobImg3.png";
import jobImg4 from "../../Images/jobImg4.png";
import jobImg5 from "../../Images/jobImg5.png";
import JobMainVideo1 from "../../Images/jobMainVideo4.mp4";

const JobSub = () => {
  // Jobs data (you can later fetch from API)
  const jobs = [
    {
      id: 1,
      img: jobComImg1,
      title: "Java Full Stack",
      location: "Bangalore",
      mode: "Online",
      skills: "Java | J2EE | Spring | Spring boot | React | MySQL",
    },
    {
      id: 2,
      img: jobComImg2,
      title: "Python Full Stack",
      location: "Bangalore",
      mode: "OnSite",
      skills: "Python | Django | React | MySQL",
    },
    {
      id: 3,
      img: jobComImg3,
      title: "Mearn Full Stack",
      location: "Bangalore",
      mode: "Online",
      skills: "MongoDB | Express | React | Node",
    },
    {
      id: 4,
      img: jobComImg4,
      title: "Web Technologies",
      location: "Bangalore",
      mode: "Online",
      skills: "HTML | CSS | JS | React",
    },
    {
      id: 5,
      img: jobComImg1,
      title: "Cyber Security",
      location: "Bangalore",
      mode: "OnSite",
      skills: "Security | Networking | Cloud",
    },
  ];

  // Dropdown open/close state
  const [openFilter, setOpenFilter] = useState(null);

  // Selected filters
  const [selectedTitles, setSelectedTitles] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedModes, setSelectedModes] = useState([]);

  // Result jobs
  const [filteredJobs, setFilteredJobs] = useState(jobs);

  // Toggle dropdown
  const toggleDropdown = (filterName) => {
    setOpenFilter(openFilter === filterName ? null : filterName);
  };

  // Handle checkbox changes
  const handleCheckbox = (value, selectedList, setSelectedList) => {
    if (selectedList.includes(value)) {
      setSelectedList(selectedList.filter((item) => item !== value));
    } else {
      setSelectedList([...selectedList, value]);
    }
  };

  // Apply search
  const handleSearch = () => {
    let result = jobs.filter((job) => {
      const titleMatch =
        selectedTitles.length === 0 || selectedTitles.includes(job.title);
      const locationMatch =
        selectedLocations.length === 0 ||
        selectedLocations.includes(job.location);
      const modeMatch =
        selectedModes.length === 0 || selectedModes.includes(job.mode);

      return titleMatch && locationMatch && modeMatch;
    });
    setFilteredJobs(result);
  };

  return (
    <div className="jobSubSection">
      <div className="jobHero">
        <video width="100%" height="100%" autoPlay muted loop>
          <source src={JobMainVideo1} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="jobHeroCover">
          <div className="jobHeroText">
            <h1>Search Your Dream Job</h1>
          </div>
          <div className="jobFilter">
            <div className="jobSubFilter">
              <div onClick={() => toggleDropdown("title")}>Job Title</div>
              <div onClick={() => toggleDropdown("location")}>Location</div>
              <div onClick={() => toggleDropdown("mode")}>Job Mode</div>
              <button onClick={handleSearch}>Search</button>
            </div>

            {/* Job Title Dropdown */}
            {openFilter === "title" && (
              <div className="jobTitleDropDown">
                {[
                  "Java Full Stack",
                  "Python Full Stack",
                  "Mearn Full Stack",
                  "Web Technologies",
                  "Cyber Security",
                ].map((title) => (
                  <div key={title}>
                    <input
                      type="checkbox"
                      checked={selectedTitles.includes(title)}
                      onChange={() =>
                        handleCheckbox(title, selectedTitles, setSelectedTitles)
                      }
                    />
                    <label>{title}</label>
                  </div>
                ))}
              </div>
            )}

            {/* Location Dropdown */}
            {openFilter === "location" && (
              <div className="jobLocationDropDown">
                {["Bangalore", "Chenai", "Hyderabad", "Kerala"].map((loc) => (
                  <div key={loc}>
                    <input
                      type="checkbox"
                      checked={selectedLocations.includes(loc)}
                      onChange={() =>
                        handleCheckbox(
                          loc,
                          selectedLocations,
                          setSelectedLocations
                        )
                      }
                    />
                    <label>{loc}</label>
                  </div>
                ))}
              </div>
            )}

            {/* Job Mode Dropdown */}
            {openFilter === "mode" && (
              <div className="jobModeDropDown">
                {["Online", "OnSite"].map((mode) => (
                  <div key={mode}>
                    <input
                      type="checkbox"
                      checked={selectedModes.includes(mode)}
                      onChange={() =>
                        handleCheckbox(mode, selectedModes, setSelectedModes)
                      }
                    />
                    <label>{mode}</label>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="jobSubSearch">
        {/* Job Cards */}
        <div className="jobSubSearchBlock">
          {filteredJobs.length > 0 ? (
            filteredJobs.map((job) => (
              <div className="jobSubCard" key={job.id}>
                <div className="jobSubImg">
                  <img src={job.img} alt={job.title} />
                  <h3>{job.title}</h3>
                </div>
                <div className="jobSubText">
                  <p>{job.skills}</p>
                  <p>Location: {job.location}</p>
                  <p>Job Mode: {job.mode}</p>
                  <div className="jobSubText2">
                    <span>5L - 8L</span>
                    <span>0 - 3 years</span>
                    <button>
                      <a href="/form">Apply</a>
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>No jobs found</p>
          )}
        </div>
      </div>
      <div className="jobSubTrend">
        <h2>Trending Jobs</h2>
        <div className="jobSubTrendBlock">
          <div className="jobSubTrendCard">
            <div className="jobSubImg">
              <img src={jobComImg1} alt={jobComImg1} />
              <h3>Java Full Stack</h3>
            </div>
            <div className="jobSubText">
              <p>Java | J2EE | Spring | Spring boot | React | MySQL</p>
              <p>Location: Bangalore</p>
              <div className="jobSubText2">
                <span>5L - 8L</span>
                <span>0 - 3 years</span>
              </div>
            </div>
          </div>
          <div className="jobSubTrendCard">
            <div className="jobSubImg">
              <img src={jobComImg1} alt={jobComImg1} />
              <h3>Java Full Stack</h3>
            </div>
            <div className="jobSubText">
              <p>Java | J2EE | Spring | Spring boot | React | MySQL</p>
              <p>Location: Bangalore</p>
              <div className="jobSubText2">
                <span>5L - 8L</span>
                <span>0 - 3 years</span>
              </div>
            </div>
          </div>
          <div className="jobSubTrendCard">
            <div className="jobSubImg">
              <img src={jobComImg1} alt={jobComImg1} />
              <h3>Java Full Stack</h3>
            </div>
            <div className="jobSubText">
              <p>Java | J2EE | Spring | Spring boot | React | MySQL</p>
              <p>Location: Bangalore</p>
              <div className="jobSubText2">
                <span>5L - 8L</span>
                <span>0 - 3 years</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Slider />
      <div className="jobSubTalent">
        <h2>Top Talent Seekers</h2>
        <div className="jobSubTalentBlock">
          <div className="jobSubTalentCard">
            <div className="jobSubTalentImg">
              <img src={jobImg1} alt="jobImg1" />
            </div>
            <h1>Google</h1>
            <p>127 opening</p>
            <div className="jobSubTalentText">
              <p>8L</p>
              <p>15L</p>
            </div>
          </div>
          <div className="jobSubTalentCard">
            <div className="jobSubTalentImg">
              <img src={jobImg2} alt="jobImg1" />
            </div>
            <h1>Amazon</h1>
            <p>85 opening</p>
            <div className="jobSubTalentText">
              <p>8L</p>
              <p>15L</p>
            </div>
          </div>
          <div className="jobSubTalentCard">
            <div className="jobSubTalentImg">
              <img src={jobImg3} alt="jobImg1" />
            </div>
            <h1>Wipro</h1>
            <p>35 opening</p>
            <div className="jobSubTalentText">
              <p>8L</p>
              <p>15L</p>
            </div>
          </div>
          <div className="jobSubTalentCard">
            <div className="jobSubTalentImg">
              <img src={jobImg4} alt="jobImg1" />
            </div>
            <h1>Mind tree</h1>
            <p>89 opening</p>
            <div className="jobSubTalentText">
              <p>8L</p>
              <p>15L</p>
            </div>
          </div>
          <div className="jobSubTalentCard">
            <div className="jobSubTalentImg">
              <img src={jobImg5} alt="jobImg1" />
            </div>
            <h1>Adobe</h1>
            <p>55 opening</p>
            <div className="jobSubTalentText">
              <p>8L</p>
              <p>15L</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobSub;
